import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="px-6 md:px-10 max-w-6xl mx-auto">
        <div className="mb-14">
          <span className="text-xs tracking-widest uppercase text-foreground-500 font-label">
            {t('section_system_label')}
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 mt-4 leading-tight max-w-2xl">
            {t('section_system_title')}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mt-8 max-w-xl leading-relaxed">
            {t('section_system_desc')}
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4">
          <div className="w-full sm:w-2/5 rounded-2xl overflow-hidden aspect-[4/3]">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20modern%20office%20desk%20with%20product%20samples%20and%20analytics%20dashboard%20on%20screen%2C%20minimal%20scandinavian%20interior%2C%20warm%20natural%20light%2C%20soft%20beige%20tones%2C%20professional%20sourcing%20workspace%2C%20elegant%20editorial%20photography%2C%20no%20text%20no%20watermark&width=600&height=450&seq=about-left-03&orientation=landscape"
              alt="YOYBUY система сорсинга"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="w-full sm:w-3/5 rounded-2xl overflow-hidden aspect-[4/3]">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20product%20sourcing%20team%20reviewing%20items%20in%20bright%20modern%20showroom%2C%20minimal%20scandinavian%20aesthetic%2C%20warm%20natural%20lighting%2C%20clean%20neutral%20background%2C%20fashion%20and%20accessories%20displayed%2C%20elegant%20editorial%20style%2C%20no%20text%20no%20watermark&width=900&height=450&seq=about-right-04&orientation=landscape"
              alt="YOYBUY аналитика поставщиков"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}